import React from "react";
import { Redirect, useParams } from "react-router-dom";
import { connectPageService } from "../../../../application/domain/base/base-application-service";

import {
  ContextProps,
  ProcManagementPlaceEditService,
} from "../../../../application/service/service-provider/proc-management/place-edit";
import { FeatureEnabledOrgOnly } from "../../../organisms/proc-management/util";
import { ServiceProviderTemplate } from "../../../template/service-provider/default-template";
import { ServiceProviderR } from "../routes";
import { Content } from "../../../organisms/proc-management/place-form";
import { isPlace } from "../../../../application/domain/proc-management";

const ProcManagementPlaceEdit: React.FC<ContextProps> = ({
  place,
  fetchPlaceById,
  onChange,
  onSave,
  isUpdating,
}) => {
  const { orgId, placeId } = useParams<{ orgId: string; placeId: string }>();
  const pageTitle = place.name && place.name.length > 0 ? place.name : placeId;
  const breadcrumbs = [
    { to: ServiceProviderR.Home.link({}), title: "テナント一覧" },
    {
      to: ServiceProviderR.ProcManagementProcsList.link({ orgId }),
      title: "手続きマスタ",
    },
    {
      to: ServiceProviderR.ProcManagementPlacesList.link({ orgId }),
      title: "場所マスタ",
    },
    {
      to: ServiceProviderR.ProcManagementPlaceDetail.link({ orgId, placeId }),
      title: pageTitle,
    },
    {
      to: ServiceProviderR.ProcManagementPlaceEdit.link({ orgId, placeId }),
      title: "編集",
    },
  ];

  React.useEffect(() => {
    fetchPlaceById(placeId);
  }, [fetchPlaceById, placeId]);
  return (
    <FeatureEnabledOrgOnly>
      <ServiceProviderTemplate breadcrumbs={breadcrumbs}>
        {isPlace(place) ? (
          <Content
            place={place}
            onChange={onChange}
            onPressSave={onSave}
            isUpdating={isUpdating}
          />
        ) : null}
      </ServiceProviderTemplate>
    </FeatureEnabledOrgOnly>
  );
};

export const ProcManagementPlaceEditContainer = connectPageService(
  ProcManagementPlaceEdit,
  () => new ProcManagementPlaceEditService(),
);

export const RedirectToProcManagementPlaceEditContainer: React.FC = () => {
  const { orgId, placeId } = useParams<{ orgId: string; placeId: string }>();
  return (
    <Redirect
      to={ServiceProviderR.ProcManagementPlaceEdit.link({ orgId, placeId })}
    />
  );
};
